  <div class="modal-header">
    <button type="button" class="close" ng-click="$dismiss()">&times;</button>
    <h3 class="modal-title">Assistente de ajuste de insumos</h3>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <div id="wizard-container">

          <div id="wizard-step-container">
            <ul class="nav nav-pills nav-justified">
              <li ng-repeat="step in $ctrl.steps"
                  ng-class="{'active':step.step == $ctrl.currentStep}">
                <a ng-click="$ctrl.goToStep(step.step)" href="">{{step.step}}. {{step.name}}</a>
              </li>
            </ul>
          </div>

          <div id="wizard-content-container">
            <ng-include src="$ctrl.getStepTemplate()"></ng-include>
          </div>
        </div>
      </div>
    </div>
  </div>
